
import { getUrlApi } from '../utilities/util';
import ApiHandler from './ApiHandlers/ApiHandler'; 
 
export const baseURL = String(getUrlApi());

export default class StationApi { 
    static async GetAllStations(): Promise<any> {
        return ApiHandler(baseURL).get("/station/getallstations");
    };  
    
    static async GetStationById(culture : string, id: number): Promise<any> {
        return ApiHandler(baseURL).get(culture + "/station/getstationbyid/" + id);
        
    }; 

    static async PostStationCreate(stationData: { name: string; description: string, sublineId: string }): Promise<any> {
        return ApiHandler(baseURL).post("/station/stationcreate", stationData);
    }

    static async DeleteStation(id: string): Promise<any> {
        return ApiHandler(baseURL).post(`/station/stationdelete`, id, {
            headers: {
                'Content-Type': 'application/json-patch+json',
            },
        });
    }
    static async UpdateStation(stationUpdateData: { id: string; name: string; description: string, sublineId: string }): Promise<any> {
        return ApiHandler(baseURL).post(`/station/stationupdate`, stationUpdateData); 
    }
    
}
